<template>
  <b-modal id="main-guest-prod-inst-image-display-modal" ref="mainGuestProdInstImageDisplayModal" :hide-header="true" :hide-footer="true" :no-close-on-backdrop="true">
    <b-overlay :show="overlayShow" rounded="sm">
      <div>
        <b-button @click="hideModal()" aria-label="Close" class="close"><b-icon-x font-scale="2"></b-icon-x></b-button>
      </div>
      <div class="text-left">
        <h5>スペック決定した商品の画像制作指示表示</h5>
      </div>
      <div class="p-0 row ml-5 mt-3" v-if="!overlayShow">
        <div class="col-12 row mt-2">
          <div class="col-1"></div>
          <div :class="mainGuestProdInstImageDisplayData['image1']['hasImage'] ? 'col-9' : 'col-9 text-black-50'">
            １:中景
          </div>
          <div class=" col-1 text-center custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="image1" :checked="mainGuestProdInstImageDisplayData['image1']['display'] && mainGuestProdInstImageDisplayData['image1']['hasImage']" v-if="mainGuestProdInstImageDisplayData['image1']['hasImage']">
            <input type="hidden" id="image1" v-else>
            <label class="custom-control-label toggle-display-image" for="image1" v-if="mainGuestProdInstImageDisplayData['image1']['hasImage']" ></label>
          </div>
        </div>
        <div class="col-12 row mt-2">
          <div class="col-1"></div>
          <div :class="mainGuestProdInstImageDisplayData['image2']['hasImage'] ? 'col-9' : 'col-9 text-black-50'">
            ２:メインテーブル
          </div>
          <div class=" col-1 text-center custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="image2" :checked="mainGuestProdInstImageDisplayData['image2']['display'] && mainGuestProdInstImageDisplayData['image2']['hasImage']" v-if="mainGuestProdInstImageDisplayData['image2']['hasImage']">
            <input type="hidden" id="image2" v-else>
            <label class="custom-control-label toggle-display-image" for="image2" v-if="mainGuestProdInstImageDisplayData['image2']['hasImage']"></label>
          </div>
        </div>
        <div class="col-12 row mt-2">
          <div class="col-1"></div>
          <div :class="mainGuestProdInstImageDisplayData['image3']['hasImage'] ? 'col-9' : 'col-9 text-black-50'">
            ３:ゲストテーブル(横長)
          </div>
          <div class=" col-1 text-center custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="image3" :checked="mainGuestProdInstImageDisplayData['image3']['display'] && mainGuestProdInstImageDisplayData['image3']['hasImage']" v-if="mainGuestProdInstImageDisplayData['image3']['hasImage']">
            <input type="hidden" id="image3" v-else>
            <label class="custom-control-label toggle-display-image" for="image3" v-if="mainGuestProdInstImageDisplayData['image3']['hasImage']"></label>
          </div>
        </div>
        <div class="col-12 row mt-2">
          <div class="col-1"></div>
          <div :class="mainGuestProdInstImageDisplayData['image4']['hasImage'] ? 'col-9' : 'col-9 text-black-50'">
            ４:ゲストテーブル(縦長)
          </div>
          <div class=" col-1 text-center custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="image4" :checked="mainGuestProdInstImageDisplayData['image4']['display'] && mainGuestProdInstImageDisplayData['image4']['hasImage']" v-if="mainGuestProdInstImageDisplayData['image4']['hasImage']">
            <input type="hidden" id="image4" v-else>
            <label class="custom-control-label toggle-display-image" for="image4" v-if="mainGuestProdInstImageDisplayData['image4']['hasImage']"></label>
          </div>
        </div>
        <div class="col-12 row mt-2">
          <div class="col-1"></div>
          <div :class="mainGuestProdInstImageDisplayData['image5']['hasImage'] ? 'col-9' : 'col-9 text-black-50'">
            ５:花合わせ
          </div>
          <div class=" col-1 text-center custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="image5" :checked="mainGuestProdInstImageDisplayData['image5']['display'] && mainGuestProdInstImageDisplayData['image5']['hasImage']" v-if="mainGuestProdInstImageDisplayData['image5']['hasImage']">
            <input type="hidden" id="image5" v-else>
            <label class="custom-control-label toggle-display-image" for="image5" v-if="mainGuestProdInstImageDisplayData['image5']['hasImage']"></label>
          </div>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
import CommonModal from '@/components/CommonModal'

export default {
  name: 'MainGuestProdInstImageDisplayModal',
  props: {
    mainGuestProdInstImageDisplayData: {
      type: Object,
      require: true
    }
  },
  components: { CommonModal },
  data () {
    return {
      overlayShow: false
    }
  },
  methods: {
    showModal () {
      this.$refs.mainGuestProdInstImageDisplayModal.show()
    },
    hideModal () {
      this.$refs.mainGuestProdInstImageDisplayModal.hide()
      for (let i = 1; i < 6; i++) {
        const elm = document.getElementById('image' + i)
        this.mainGuestProdInstImageDisplayData['image' + i]['display'] = elm.type === 'checkbox' ? elm.checked : false
      }
      this.$emit('setMainGuestProdInstImageDisplayData', this.mainGuestProdInstImageDisplayData)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/MainGuestProdInstImageDisplayModal.vue